import AddTodo from './AddTodo';
import AddTodoItem from './AddTodoItem';

const TodoContainer = () => (
  <>
    <AddTodo />
    <AddTodoItem />
  </>
);

export default TodoContainer;
